"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authLink = authLink;
const jwt_client_utils_1 = require("@daytrip/jwt-client-utils");
const trpc_refresh_token_link_1 = require("./trpc-refresh-token-link");
/**
 * Creates a tRPC link that handles JWT authentication with automatic token refresh
 *
 * This link:
 * - Proactively refreshes expired tokens before requests
 * - Ensures only one refresh request at a time
 * - Calls callbacks for successful refresh or failures
 *
 * Note: This link does NOT add Authorization headers to requests.
 * You must configure the httpLink with a headers function to add the Authorization header.
 *
 * @param opts Configuration options
 * @returns tRPC link for authentication
 */
function authLink(opts) {
    const { getToken, fetchAccessToken, onTokenRefreshed, onRefreshFailed } = opts;
    return (0, trpc_refresh_token_link_1.tokenRefreshLink)({
        tokenRefreshNeeded: () => {
            const token = getToken();
            // If token is present and is expired, refresh is needed
            return !!token && (0, jwt_client_utils_1.isTokenExpired)(token);
        },
        fetchAccessToken: async (op) => {
            try {
                const tokenPair = await fetchAccessToken(op);
                if (tokenPair) {
                    onTokenRefreshed(tokenPair);
                }
                else {
                    // Refresh failed
                    onRefreshFailed();
                }
            }
            catch (error) {
                onRefreshFailed();
            }
        },
    });
}
//# sourceMappingURL=auth.link.js.map